const onlyNumbers = (val) => {
	if (val && typeof val === 'string') {
		return val.replace(/\D/g,'')
	}
	return val
}

export default onlyNumbers
